export const passwordFormatRegx = /^\d{6}$/;
